import React from "react";
import { VideoType } from "../../../../types";
import YouTubeEmbed from "../../../external/youtube-embed/YouTubeEmbed";

type Props = {
    videos: VideoType[];
};

export const Videos = ({ videos }: Props) => (
    <div className="pt-3 space-y-3">
        {videos.map((video) => (
                <YouTubeEmbed key={video.videoId} {...video} />
))}
</div>
);
